export const TONKHO_LIST_INITING             = 'TONKHO_LIST_INITING'
export const TONKHO_LIST_REQUESTING          = 'TONKHO_LIST_REQUESTING'
export const TONKHO_LIST_SUCCESS             = 'TONKHO_LIST_SUCCESS'
export const TONKHO_LIST_ERROR               = 'TONKHO_LIST_ERROR'   

export const TONKHO_EXPORT_REQUESTING        = 'TONKHO_EXPORT_REQUESTING'
export const TONKHO_EXPORT_SUCCESS           = 'TONKHO_EXPORT_SUCCESS'
export const TONKHO_EXPORT_ERROR             = 'TONKHO_EXPORT_ERROR'  

export const TONKHO_UPLOAD_REQUESTING        = 'TONKHO_UPLOAD_REQUESTING'
export const TONKHO_UPLOAD_SUCCESS           = 'TONKHO_UPLOAD_SUCCESS'
export const TONKHO_UPLOAD_ERROR             = 'TONKHO_UPLOAD_ERROR'  

export const TONKHO_KHO_LIST_INITING         = 'TONKHO_KHO_LIST_INITING'
export const TONKHO_KHO_LIST_REQUESTING      = 'TONKHO_KHO_LIST_REQUESTING'
export const TONKHO_KHO_LIST_SUCCESS         = 'TONKHO_KHO_LIST_SUCCESS'
export const TONKHO_KHO_LIST_ERROR           = 'TONKHO_KHO_LIST_ERROR' 

export const TONKHO_DETAIL_INITING           = 'TONKHO_DETAIL_INITING'
export const TONKHO_DETAIL_REQUESTING        = 'TONKHO_DETAIL_REQUESTING'
export const TONKHO_DETAIL_SUCCESS           = 'TONKHO_DETAIL_SUCCESS'
export const TONKHO_DETAIL_ERROR             = 'TONKHO_DETAIL_ERROR'   

export const TONKHO_UPDATE_REQUESTING        = 'TONKHO_UPDATE_REQUESTING'
export const TONKHO_UPDATE_SUCCESS           = 'TONKHO_UPDATE_SUCCESS'
export const TONKHO_UPDATE_ERROR             = 'TONKHO_UPDATE_ERROR'   

export const TONKHO_DETAIL_API               = '/api/v1/tonkho/tonkho_detail_by_id'  
export const TONKHO_LIST_API                 = '/api/v1/tonkho/tonkho_get_list_product_by_store'
export const TONKHO_EXPORT_API               = '/api/v1/tonkho/tonkho_export_by_store'  
export const TONKHO_UPLOAD_API               = '/api/v1/tonkho/tonkho_upload'   
export const TONKHO_UPDATE_API               = '/api/v1/tonkho/tonkho_update_by_id' 
export const TONKHO_KHO_LIST_API             = '/api/v1/kho/getKhoAllOfUser' 


// WEBPACK FOOTER //
// ./src/views/TonKho/constants.js